
const common = {
  nav: {
    home: 'Home',
    about: 'About',
    products: 'Products',
    solutions: 'Solutions',
    contact: 'Contact',
    privacy: 'Privacy',
    terms: 'Terms'
  },
  footer: {
    company: 'Company',
    products: 'Products',
    support: 'Support',
    legal: 'Legal',
    contact: 'Contact Us',
    email: 'business@deriway.com',
    telegram: '@deriway_business',
    copyright: 'All rights reserved.',
    poweredBy: 'Powered by Readdy',
    quickLinks: 'Quick Links',
    legalSupport: 'Legal & Support',
    newsletter: 'Subscribe to Our Newsletter',
    newsletterDesc: 'Get the latest fintech news and product updates',
    emailPlaceholder: 'Enter your email address',
    subscribe: 'Subscribe',
    partners: 'Partners & Certifications'
  },
  buttons: {
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    contactUs: 'Contact Us',
    submit: 'Submit',
    cancel: 'Cancel',
    close: 'Close'
  }
};

export default common;